// ye file video call aur audio call dono ke liye important hai to please koi bhi isko delete ya change nhi krega.
import React, { useEffect, useRef } from "react";
import { ChatSocket } from "../APIServices/GoServerApi/chatService";
import useAudioCall from "../APIServices/GoServerApi/useAudioCall";
import useVideoCall from "../APIServices/GoServerApi/useVideoCall";
import AudioCallPopups from "./AudioCallPopups";
import ReceivedAudioCallPopups from "./ReceivedAudioCallPopups";
import ReceivedVideoCallPopus from "./ReceivedVideoCallPopus";
import VideoCallOutgoingPopups from "./VideoCallOutgoingPopups";
import VideoCallScreenDesign from "./VideoCallScreenDesign";

const AdminAudioCallManager = ({
    adminUserId,
    adminName,
}) => {
    const wsRef = useRef(null);

    const audioCallManager = useAudioCall({
        wsRef,
        currentUserId: adminUserId || "",
    });

    const videoCallManager = useVideoCall({
        wsRef,
        currentUserId: adminUserId || "",
    });

    const audioHandleRef = useRef(audioCallManager.handleSocketEvent);
    const videoHandleRef = useRef(videoCallManager.handleSocketEvent);

    useEffect(() => {
        audioHandleRef.current = audioCallManager.handleSocketEvent;
    }, [audioCallManager.handleSocketEvent]);

    useEffect(() => {
        videoHandleRef.current = videoCallManager.handleSocketEvent;
    }, [videoCallManager.handleSocketEvent]);

    useEffect(() => {
        if (!adminUserId) {
            console.warn("AdminAudioCallManager: adminUserId missing");
            return;
        }

        const socket = new ChatSocket({
            userId: adminUserId,
            name: adminName || adminUserId,
            autoReconnect: true,
            onEvent: (type, data) => {
                audioHandleRef.current?.(type, data);
                videoHandleRef.current?.(type, data);
            },
        });

        wsRef.current = socket;
        socket.connect();

        return () => {
            try {
                socket.disconnect();
            } catch { }
            wsRef.current = null;
        };
    }, [adminUserId, adminName]);

    if (!adminUserId) return null;

    const adminLocalName = adminName || "Admin";
    const visitorRemoteName =
        videoCallManager.activeCall?.userName ||
        videoCallManager.incomingCall?.userName ||
        videoCallManager.activeCall?.from ||
        videoCallManager.incomingCall?.from ||
        "Visitor";

    return (
        <>
            <audio ref={audioCallManager.remoteAudioRef} autoPlay playsInline />

            <ReceivedAudioCallPopups
                visible={audioCallManager.callState === "incoming"}
                callerName={
                    audioCallManager.incomingCall?.userName ||
                    audioCallManager.incomingCall?.from ||
                    "Visitor"
                }
                onAccept={audioCallManager.acceptIncomingCall}
                onReject={audioCallManager.rejectIncomingCall}
            />

            <AudioCallPopups
                visible={
                    audioCallManager.callState === "outgoing" ||
                    audioCallManager.callState === "connecting" ||
                    audioCallManager.callState === "connected" ||
                    audioCallManager.callState === "ended" ||
                    !!audioCallManager.error
                }
                title={
                    audioCallManager.error
                        ? "Audio Call Error"
                        : audioCallManager.callState === "outgoing"
                            ? "Calling..."
                            : audioCallManager.callState === "connecting"
                                ? "Connecting..."
                                : audioCallManager.callState === "connected"
                                    ? "Audio Call Connected"
                                    : "Call Ended"
                }
                subTitle={
                    audioCallManager.error ||
                    audioCallManager.activeCall?.userName ||
                    audioCallManager.activeCall?.from ||
                    "Visitor"
                }
                onCancel={audioCallManager.endCall}
            />

            <ReceivedVideoCallPopus
                visible={videoCallManager.callState === "incoming"}
                callerName={
                    videoCallManager.incomingCall?.userName ||
                    videoCallManager.incomingCall?.from ||
                    "Visitor"
                }
                onAccept={videoCallManager.acceptIncomingCall}
                onReject={videoCallManager.rejectIncomingCall}
            />

            <VideoCallOutgoingPopups
                visible={
                    videoCallManager.callState === "outgoing" ||
                    videoCallManager.callState === "connecting" ||
                    !!videoCallManager.error
                }
                title={
                    videoCallManager.error
                        ? "Video Call Error"
                        : videoCallManager.callState === "outgoing"
                            ? "Calling..."
                            : "Connecting video..."
                }
                subTitle={
                    videoCallManager.error ||
                    videoCallManager.activeCall?.userName ||
                    videoCallManager.activeCall?.from ||
                    "Visitor"
                }
                onCancel={videoCallManager.endCall}
            />

            <VideoCallScreenDesign
                visible={videoCallManager.callState === "connected"}
                localVideoRef={videoCallManager.localVideoRef}
                remoteVideoRef={videoCallManager.remoteVideoRef}
                localName={adminLocalName}
                remoteName={visitorRemoteName}
                onEndCall={videoCallManager.endCall}
                isMicEnabled={videoCallManager.isMicEnabled}
                isCameraEnabled={videoCallManager.isCameraEnabled}
                isScreenSharing={videoCallManager.isScreenSharing}
                onToggleMic={videoCallManager.toggleMic}
                onToggleCamera={videoCallManager.toggleCamera}
                onToggleScreenShare={videoCallManager.toggleScreenShare}
            />
        </>
    );
};

export default AdminAudioCallManager;